<header class="header">
    <nav class="navbar py-1" [ngClass]="{ 'dev-theme': is_dev }">
        <div class="container-fluid">
            <div
                class="navbar-holder d-flex align-items-center justify-content-between">
                <!-- Navbar Header-->
                <div class="navbar-header">
                    <div class="d-flex align-items-center">
                        <!-- Toggle Button-->
                        <button
                            id="toggle-btn"
                            (click)="toggleSidebar()"
                            class="btn btn-outline-light mr-2 d-xl-none">
                            <i class="fa fa-bars"></i>
                        </button>
                        <!-- Navbar Brand -->
                        <div
                            class="navbar-brand p-2 mx-1"
                            (click)="gotoHome()"
                            style="cursor: pointer">
                            <img
                                alt="logo-lccv"
                                src="assets/images/logo_lccv_icon.png"
                                class="img-fluid mr-1"
                                width="40px" />
                        </div>
                        <div
                            class="navbar-brand p-2 mx-1"
                            (click)="gotoHome()"
                            style="cursor: pointer">
                            <div class="brand-text d-none d-lg-inline-block">
                                <strong>LCCV</strong>
                            </div>
                            <div
                                class="brand-text d-none d-sm-inline-block d-lg-none">
                                <strong>LCCV</strong>
                            </div>
                        </div>
                        <span
                            class="d-none d-sm-inline-block"
                            *ngIf="portalService.titulo$ | async"
                            >|</span
                        >
                        <span
                            class="p-2 mx-1 d-none d-sm-inline-block"
                            style="cursor: pointer"
                            (click)="gotoHome()">
                            {{ portalService.titulo$ | async }}
                        </span>
                    </div>
                </div>
                <!-- Navbar Menu -->
                <ul
                    class="nav-menu list-unstyled d-flex flex-md-row align-items-md-center">
                    <!-- Theme Selector -->
                    <li class="nav-item">
                        <button
                            mat-button
                            (click)="darkThemeService.onDarkMode()">
                            <span class="material-icons">
                                {{
                                    darkThemeService.enabled
                                        ? 'brightness_high'
                                        : 'brightness_medium'
                                }}
                            </span>
                        </button>
                    </li>
                    <!-- Portais selector -->
                    <li
                        *ngIf="apiAuth.isLogged"
                        class="nav-item dropdown"
                        style="position: relative">
                        <ngx-spinner
                            name="seletor-portais"
                            [fullScreen]="false"
                            type="ball-scale-multiple"></ngx-spinner>
                        <a
                            id="portais"
                            rel="nofollow"
                            data-target="#"
                            href="#"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            class="nav-link language dropdown-toggle">
                            <span class="">Portais</span></a
                        >
                        <ul aria-labelledby="portais" class="dropdown-menu">
                            <li *ngFor="let portal of portalService.portais">
                                <a
                                    rel="nofollow"
                                    [routerLink]="portal.link"
                                    class="dropdown-item"
                                    >{{ portal.titulo }}</a
                                >
                            </li>
                        </ul>
                    </li>
                    <!-- Logout -->
                    <li class="nav-item d-flex flex-row align-items-center">
                        <div *ngIf="apiAuth.isLogged">
                            <button
                                (click)="logoutUser()"
                                class="nav-link logout">
                                <div class="d-flex flex-row align-items-center">
                                    <span class="d-none d-sm-inline">Sair</span
                                    ><i class="fa fa-sign-out"></i>
                                </div>
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
    <div class="d-sm-none d-flex justify-content-center bg-secondary p-1">
        <span class="text-white" style="cursor: pointer" (click)="gotoHome()">
            {{ portalService.titulo$ | async }}
        </span>
    </div>
</header>
